<template>
  <div class="cont">
    <div>NOT FOUND</div>
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
.cont {
  display: flex;
  height: 100vh;
  width: 100vw;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 4em;
}
</style>